import React, { useEffect, useState } from 'react';
import api from '../../config/axios';
import {
    Button,
    Card,
    CardContent,
    CircularProgress,
    Container,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    Grid,
    IconButton,
    InputLabel,
    MenuItem,
    Select,
    Stack,
    TableCell,
    TableRow,
    TextField,
    Typography,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { toast } from 'react-toastify';
import CustomTable from '../ui/CustomTable';
const DiscountsSetting = () => {
    const [discounts, setDiscounts] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [selectedDiscount, setSelectedDiscount] = useState(null);

    useEffect(() => {
        fetchAllDiscounts();
    }, []);

    const fetchAllDiscounts = async () => {
        setLoading(true);
        try {
            const response = await api.get('/admin-settings/get-bonus');
            setDiscounts(response.data.Bonus);
        } catch (error) {
            console.error('Error fetching bonuses:', error);
        } finally {
            setLoading(false);
        }
    };
    const handleCreateClick = () => {
        setSelectedDiscount(null);
        setIsModalOpen(true);
    };

    const handleEditClick = (discount) => {
        setSelectedDiscount(discount);
        setIsModalOpen(true);
    };

    const handleDeleteSuccess = () => {
        fetchAllDiscounts();
    };
    return (
        <>
            <CustomTable
                loading={loading}
                title="Bonuses"
                end={
                    <Button onClick={handleCreateClick} variant="contained">
                        Create Bonus
                    </Button>
                }
                fields={['#', 'TYPE', 'BONUS', 'MINAMOUNT', 'ACTIONS']}>
                {discounts?.map((discount, i) => (
                    <DiscountCard
                        discount={discount}
                        i={i}
                        onEdit={handleEditClick}
                        onDeleteSuccess={handleDeleteSuccess}
                    />
                ))}
            </CustomTable>

            <DiscountFormModal
                open={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                selectedDiscount={selectedDiscount}
                onSuccess={fetchAllDiscounts}
            />
        </>
    );
};

const DiscountCard = ({ discount, onEdit, onDeleteSuccess, i }) => {
    const [isConfirmOpen, setIsConfirmOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleDelete = async () => {
        setLoading(true);
        try {
            const response = await api.post(`/admin-settings/delete-bonus/${discount._id}`, {});
            if (response.status === 201) {
                toast.success('Bonus delete successfully');
            } else {
                toast.error('Failed to delete Bonus. Please try again.');
            }
            onDeleteSuccess();
            setIsConfirmOpen(false);
        } catch (error) {
            console.error('Error deleting Bonus:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <TableRow>
                <TableCell>{i + 1}</TableCell>
                <TableCell>{discount.type}</TableCell>
                <TableCell
                    sx={{
                        color: 'primary.main',
                    }}>
                    {discount.bonus}%
                </TableCell>
                <TableCell>${discount.minAmount}</TableCell>
                <TableCell>
                    <Stack direction={'row'}>
                        <IconButton onClick={() => onEdit(discount)}>
                            <EditIcon color="warning" />
                        </IconButton>
                        <IconButton onClick={() => setIsConfirmOpen(true)}>
                            <DeleteIcon color="error" />
                        </IconButton>
                    </Stack>
                </TableCell>
            </TableRow>

            <ConfirmationModal
                loading={loading}
                open={isConfirmOpen}
                onClose={() => setIsConfirmOpen(false)}
                onConfirm={handleDelete}
                message="Are you sure you want to delete this bonus?"
            />
        </>
    );
};
const DiscountFormModal = ({ open, onClose, selectedDiscount, onSuccess }) => {
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        type: selectedDiscount?.type || '',
        bonus: selectedDiscount?.discount || 0,
        minAmount: selectedDiscount?.minAmount || 0,
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            if (selectedDiscount) {
                const response = await api.put(`/admin-settings/update-bonus/${selectedDiscount._id}`, formData);
                if (response.status === 201) {
                    toast.success('Bonus updated successfully');
                } else {
                    toast.error('Failed to updated Bonus. Please try again.');
                }
            } else {
                const response = await api.post('/admin-settings/add-bonus', formData);
                if (response.status === 201) {
                    toast.success('Bonus added successfully');
                } else {
                    toast.error('Failed to add Bonus. Please try again.');
                }
            }
            onSuccess();
            onClose();
        } catch (error) {
            console.error('Error submitting form:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                    background: '#1F1F1F',
                },
            }}>
            <DialogTitle sx={{ color: '#fff' }}>{selectedDiscount ? 'Edit Bonus' : 'Create Bonus'}</DialogTitle>
            <DialogContent>
                <form onSubmit={handleSubmit}>
                    <FormControl fullWidth sx={{ mb: 2 }}>
                        <InputLabel>Type</InputLabel>
                        <Select name="type" value={formData.type} onChange={handleChange} label="Type">
                            <MenuItem value="Zelle">Zelle</MenuItem>
                            <MenuItem value="Crypto">Crypto</MenuItem>
                            <MenuItem value="CreditCard">Credit Card</MenuItem>
                        </Select>
                    </FormControl>
                    <TextField
                        fullWidth
                        label="Bonus (%)"
                        name="bonus"
                        type="number"
                        value={formData.bonus}
                        onChange={handleChange}
                        sx={{ mb: 2 }}
                    />
                    <TextField
                        fullWidth
                        label="Minimum Amount"
                        name="minAmount"
                        type="number"
                        value={formData.minAmount}
                        onChange={handleChange}
                        sx={{ mb: 2 }}
                    />

                    <div className="d-flex mt-2 justify-content-end ">
                        <Button onClick={onClose}>Cancel</Button>
                        <Button type="submit" variant="contained">
                            {loading ? (
                                <CircularProgress size={24} />
                            ) : selectedDiscount ? (
                                'Edit Bonus'
                            ) : (
                                'Create Bonus'
                            )}
                        </Button>
                    </div>
                </form>
            </DialogContent>
        </Dialog>
    );
};
const ConfirmationModal = ({ open, onClose, onConfirm, message, loading }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                    background: '#1F1F1F',
                },
            }}>
            <DialogTitle sx={{ color: '#fff' }}>Confirm Action</DialogTitle>
            <DialogContent>{message}</DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button onClick={onConfirm} color="error">
                    Confirm
                    {loading ? <CircularProgress size={24} /> : 'Confirm'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
export default DiscountsSetting;
